import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { getSeriesColors } from '../../dashboardChartColors';

const CHART_HEIGHT = 280;

function DashboardAreaChart({ series = [], stacked = true }) {
    const categories = series.map((item) => item.label);
    const values = series.map((item) => item.value);
    const colors = getSeriesColors(series);

    const options = {
        chart: {
            type: 'area',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
            stacked,
            sparkline: { enabled: false },
        },
        colors,
        stroke: {
            curve: 'smooth',
            width: 3,
        },
        fill: {
            type: 'solid',
            opacity: 0.2,
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories,
            labels: {
                rotate: -25,
                style: { fontSize: '11px', colors: '#6c757d' },
            },
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            labels: {
                style: { colors: '#6c757d', fontSize: '12px' },
                formatter: (val) => Math.round(val).toLocaleString(),
            },
        },
        grid: {
            borderColor: '#f1f3f8',
            strokeDashArray: 4,
        },
        legend: { show: false },
        tooltip: {
            y: { formatter: (val) => val.toLocaleString() },
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={[{ name: 'Volume', data: values }]}
            type="area"
            height={CHART_HEIGHT}
            width="100%"
        />
    );
}

export default DashboardAreaChart;
